import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { MATCHED_PHOTOS_SORT } from '../../../../../../../constants/photos';
import DropdownMenu from '../../../../../../../components/global/DropdownMenu';
import CustomControl from '../../../../../../../components/global/CustomControl';
import SortIcon from '../../../../../../../components/icons/SortIcon';
import Angle from '../../../../../../../components/global/Angle';

const FILTERS = [
  {
    label: 'Best',
    value: MATCHED_PHOTOS_SORT.BEST_SCORE,
  },
  {
    label: 'Most recent match',
    value: MATCHED_PHOTOS_SORT.MOST_RECENT,
  },
  {
    label: 'Most recent upload',
    value: MATCHED_PHOTOS_SORT.MOST_RECENT_UPLOAD,
  },
  {
    label: 'Least recent match',
    value: MATCHED_PHOTOS_SORT.LEAST_RECENT,
  },
  {
    label: 'Least recent upload',
    value: MATCHED_PHOTOS_SORT.LEAST_RECENT_UPLOAD,
  },
];

const propTypes = {
  selectedFilter: PropTypes.oneOf(Object.keys(MATCHED_PHOTOS_SORT)),
  setSelectedFilter: PropTypes.func.isRequired,
};

const MatchedPhotosSortFilter = ({
  selectedFilter = MATCHED_PHOTOS_SORT.MOST_RECENT,
  setSelectedFilter,
  className,
}) => {
  const classes = classNames({
    'dropdown-menu-dark': true,
    [className]: !!className,
  });
  const filterLabel = FILTERS.find(f => f.value === selectedFilter).label;

  return (
    <div className={classes}>
      <DropdownMenu
        placement="bottom-end"
        toggle={
          <div className="text-light">
            <SortIcon size={12} color="#798588" /> {filterLabel}{' '}
            <Angle direction="down" />
          </div>
        }
      >
        <p className="text-extra-bold text-light">SORT MATCHES BY</p>
        {FILTERS.map(filter => (
          <CustomControl
            key={filter.value}
            id={filter.value}
            name={filter.value}
            type="radio"
            label={filter.label}
            className="d-block mb-0 text-bold"
            checked={selectedFilter === filter.value}
            onClick={() => setSelectedFilter(filter.value)}
            size="sm"
          />
        ))}
      </DropdownMenu>
    </div>
  );
};

MatchedPhotosSortFilter.propTypes = propTypes;

export default MatchedPhotosSortFilter;
